import { Link } from "wouter";
import { toast } from "sonner";
import { useLanguage } from "@/contexts/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();

  const FOOTER_LINKS = {
    [t("footer.platform")]: [
      { label: "Science LLMs", href: "/llms" },
    ],
    [t("footer.developers")]: [
      { label: t("footer.documentation"), href: "/docs" },
      { label: t("footer.apiReference"), href: "/docs/api-reference" },
      { label: "Python SDK", href: "/docs/sdk" },
      { label: t("footer.quickstart"), href: "/docs/quickstart" },
    ],
    [t("footer.legal")]: [
      { label: t("footer.privacy"), href: "/privacy" },
      { label: t("footer.terms"), href: "/terms" },
      { label: t("footer.dataSecurity"), href: "/security" },
    ],
  };
  return (
    <footer className="border-t border-border bg-[var(--page-bg-alt)]">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="col-span-2">
            <Link href="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center"
                style={{ background: 'linear-gradient(135deg, #2563EB 0%, #06B6D4 50%, #818CF8 100%)' }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 3h6v8l4 7H5l4-7V3z" />
                  <path d="M9 3h6" />
                  <circle cx="12" cy="15" r="1" fill="white" stroke="none" />
                  <circle cx="10" cy="13" r="0.5" fill="white" stroke="none" />
                  <circle cx="14" cy="14" r="0.5" fill="white" stroke="none" />
                </svg>
              </div>
              <span className="font-bold text-lg text-white" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                Science<span className="text-blue-400">Token</span>
              </span>
            </Link>
            <p className="text-sm text-slate-500 leading-relaxed mb-6 max-w-[260px]">
              {t("footer.brand")}
            </p>
          </div>

          {/* Links */}
          {Object.entries(FOOTER_LINKS).map(([category, links]) => (
            <div key={category}>
              <h4 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-4">
                {category}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    {["/llms", "/docs", "/docs/api-reference", "/docs/sdk", "/docs/quickstart"].includes(link.href) ? (
                      <Link
                        href={link.href}
                        className="text-sm text-slate-500 hover:text-slate-300 transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <button
                        onClick={() => toast.info(t("footer.comingSoon"), { description: `${link.label} ${t("footer.comingSoonDesc")}` })}
                        className="text-sm text-slate-500 hover:text-slate-300 transition-colors text-left"
                      >
                        {link.label}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-600">
            {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-2 text-xs text-slate-600">
            <span className="status-dot" style={{ width: 6, height: 6 }} />
            <span>{t("footer.allSystems")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
